


































































































import {Component} from 'vue-property-decorator';
import {Getter} from "vuex-class";
import PartnerUsersFilter from "@/components/UserManagement/PartnerUsers/PartnerUsersFilter.vue";
import {ScrollButton} from "wings-ui-components";
import BaseItemsPage from "@/pages/Pages/BaseItemsPage";
import { BlacklistItem } from '@/store/settings/blacklists/types'
import {DateTime} from "luxon";
import BlackListsFilter from "@/components/Settings/BlackLists/BlackListsFilter.vue";
import AccountsFilter from "@/components/Settings/Accounts/AccountsFilter.vue";

@Component({components: {AccountsFilter, BlackListsFilter, PartnerUsersFilter, ScrollButton},filters: {
    date(value: string) {
      if (!value) return;
      return DateTime.fromISO(value).toFormat('dd.LL.yyyy HH:mm:ss')
    }
  }})
export default class BlackLists extends BaseItemsPage<BlacklistItem>{
  @Getter("blacklists") blacklistsResponse: any;
  private is_show_filter = false;
  currentSort = "name";
  currentSortOrder = "desc";
  tableFields = ['name', 'create_date', 'partner', 'partner_user', 'recipients_count', 'description',];

  getData(): any {
    return this.blacklistsResponse;
  }
}
